// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"ab5143bc","368":"a4303382","447":"281f039f","566":"041629a5","587":"f6d18503","629":"97a13273","719":"325a5662","937":"58ebbee6","938":"74e54195"}[chunkId] + ".chunk.js";
};